import React from "react";
import { formatReadableDate, formatReadableDateAndTime, humanReadableDate, humanReadableDateTime } from "rylak-common/src/utils";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";

export default function HumanReadableDateTimeHover({ dateTime, contentFn = humanReadableDateTime }) {
    return (
        <TurnrTooltip tight={true} content={formatReadableDateAndTime({ dateTime: dateTime })}>
            {contentFn({ dateTime })}
        </TurnrTooltip>
    );
}

export function HumanReadableDateHover({ dateTime }) {
    return (
        <TurnrTooltip tight={true} content={formatReadableDate({ dateTime })}>
            {humanReadableDate({ dateTime })}
        </TurnrTooltip>
    );
}
